import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';

const variants = {
  beforeEnter: direction => ({
    opacity: 0,
    zIndex: 1,
    x: direction === 'next' ? '80%' : '-80%',
  }),
  enter: {
    opacity: 1,
    zIndex: 1,
    x: '0%',
    transition: {
      when: 'beforeChildren',
      opacity: { duration: 0.15 },
      default: { duration: 0.3 },
    },
  },
  exit: direction => ({
    opacity: 0,
    zIndex: 1,
    x: direction === 'next' ? '-80%' : '80%',
    transition: {
      opacity: { duration: 0.15 },
      default: { duration: 0.3 },
    },
  }),
};

export const RouteTransitionWrapper = ({ children, direction, name, disabled = false }) => {
  if (disabled || !name || !direction) {
    return <>{children}</>;
  }

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        initial="beforeEnter"
        animate="enter"
        exit="exit"
        variants={variants}
        custom={direction}
        key={name}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

RouteTransitionWrapper.propTypes = {
  direction: PropTypes.oneOf(['back', 'next']).isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};
